// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Change colors in this file to style to your needs on a global level. 
Certain colors are used for different and multiply types of elements. 
For greater control over colors visit each components .scss file. */
.small-dark {
  color: #ffffff !important;
}

.blog-container {
  border-radius: 10px;
  color: #586069;
  background-color: #fff;
  box-shadow: 0 0 36px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  height: 200px;
}

.blog-title {
  color: #262626;
  font-size: 1.375rem;
  line-height: 24px;
  font-weight: 700;
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 14px;
  margin-top: 32px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.small {
  font-size: 1.063rem;
  font-weight: 400;
  line-height: 1.5rem;
  color: #666666;
  padding: 0px 20px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  margin: 0px;
}

.go-corner {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 32px;
  height: 32px;
  overflow: hidden;
  top: 0;
  right: 0;
  background-color: #55198b;
  border-radius: 0 4px 0 32px;
}

.go-arrow {
  margin-top: -4px;
  margin-right: -4px;
  color: #ffffff;
  font-family: courier, sans;
}

.blog-card {
  display: block;
  position: relative;
  background-color: transparent;
  border-radius: 4px;
  text-decoration: none;
  z-index: 0;
  overflow: hidden;
  height: 100%;
}

.blog-card::before {
  content: "";
  position: absolute;
  z-index: -1;
  top: -16px;
  right: -16px;
  background: #55198b;
  height: 32px;
  width: 32px;
  border-radius: 32px;
  transform: scale(1);
  transform-origin: 50% 50%;
  transition: transform 0.4s ease-out;
}

.blog-card:hover::before {
  transform: scale(30);
}

.blog-card:hover > .small {
  transition: all 0.3s ease-out;
  color: rgba(255, 255, 255, 0.8);
}

.blog-card:hover > h3 {
  transition: all 0.3s ease-out;
  color: #ffffff;
}

@media screen and (max-width: 480px) and (min-width: 300px), (min-width: 925px) and (max-width: 1024px), (min-width: 1405px) and (max-width: 1550px) {
  .blog-card:hover::before {
    transform: scale(30);
  }
}
@media screen and (min-width: 481px) and (max-width: 675px), (min-width: 1025px) and (max-width: 1404px), (min-width: 1551px) {
  .blog-card:hover::before {
    transform: scale(40);
  }
  .blog-card::before {
    transition: transform 0.45s ease-out;
  }
}
@media screen and (min-width: 675px) and (max-width: 860px) {
  .blog-card:hover::before {
    transform: scale(50);
  }
  .blog-card::before {
    transition: transform 0.5s ease-out;
  }
}
@media screen and (min-width: 860px) and (max-width: 924px) {
  .blog-card:hover::before {
    transform: scale(60);
  }
  .blog-card::before {
    transition: transform 0.5s ease-out;
  }
}
@media screen and (max-width: 480px) and (min-width: 300px) {
  .blog-title {
    font-size: 1.125rem;
  }
}
.blog-card-shadow {
  box-shadow: 1px 0px 20px #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/_globalColor.scss","webpack://./src/components/blogCard/BlogCard.scss"],"names":[],"mappings":"AAAA;;mEAAA;ACEA;EACE,yBAAA;AAEF;;AACA;EACE,mBAAA;EACA,cD4BuB;EC3BvB,sBDwBiB;ECvBjB,uCAAA;EACA,eAAA;EACA,aAAA;AAEF;;AACA;EACE,cDDmB;ECEnB,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;AAEF;;AACA;EACE,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cDrBa;ECsBb,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,WAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,MAAA;EACA,QAAA;EACA,yBDhDY;ECiDZ,2BAAA;AAEF;;AACA;EACE,gBAAA;EACA,kBAAA;EACA,cD1Cc;EC2Cd,0BAAA;AAEF;;AACA;EACE,cAAA;EACA,kBAAA;EACA,6BAAA;EACA,kBAAA;EACA,qBAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;AAEF;;AACA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,mBD5EY;EC6EZ,YAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mCAAA;AAEF;;AACA;EACE,oBAAA;AAEF;;AACA;EACE,6BAAA;EACA,+BD9BwB;ACgC1B;;AACA;EACE,6BAAA;EACA,cDtDe;ACwDjB;;AACA;EAGE;IACE,oBAAA;EAAF;AACF;AAGA;EAGE;IACE,oBAAA;EAHF;EAKA;IACE,oCAAA;EAHF;AACF;AAMA;EACE;IACE,oBAAA;EAJF;EAMA;IACE,mCAAA;EAJF;AACF;AAOA;EACE;IACE,oBAAA;EALF;EAOA;IACE,mCAAA;EALF;AACF;AAQA;EACE;IACE,mBAAA;EANF;AACF;AAQA;EACE,gCAAA;AANF","sourcesContent":["/* Change colors in this file to style to your needs on a global level. \nCertain colors are used for different and multiply types of elements. \nFor greater control over colors visit each components .scss file. */\n\n// button colors\n$buttonColor: #55198b;\n$buttonHover: #8c43ce;\n$topButtonHover: #000;\n\n// text colors light theme\n$titleColor: #000000;\n$textColor: #000000;\n$subTitle: #868e96;\n$cardSubtitle: #666666;\n$talkCardSubTitle: #7f8287;\n$blogCardTitleColor: #262626;\n\n// text color dark theme\n$textColorDark: #ffffff;\n\n// toggle switch colors\n$toggleCheck: #2196f3;\n$toggleSwitchSliderBG: #ccc;\n\n// githubRepo specific colors\n$githubRepoCardLanguageColorBG: #0000ff;\n$githubRepoCardColor: rgb(88, 96, 105);\n$githubRepoCardRepoCardStatsColor: rgb(106, 115, 125);\n$githubRepoCardRepoNameColor: rgb(36, 41, 46);\n$githubProfileCardLocationTS: #ffebcd;\n$githubProfileCardBorder: #6c63ff;\n\n// light background colors\n$lightBackground1: #fff;\n$lightBackground2: rgb(255, 255, 255);\n$lightBackground3: #f5f2f4;\n$blogCardContainerColor: #586069;\n// dark background colors\n$darkBackground: #171c28;\n\n// light theme box shadows\n$lightBoxShadowDark: rgba(0, 0, 0, 0.2);\n$lightBoxShadow: rgba(0, 0, 0, 0.1);\n$lightBoxShadowDarker: rgba(0, 0, 0, 0.3);\n\n// dark theme box shadows\n$darkBoxShadow: #d9dbdf;\n$darkBoxShadow2: #ffffff;\n\n// linear gradients\n$experienceCardBlurredDivLG: linear-gradient(\n  rgba(0, 0, 0, 0.4),\n  rgba(0, 0, 0, 0.2)\n);\n$experienceCardBannerLG: linear-gradient(\n  rgba(0, 0, 0, 0.7),\n  rgba(0, 0, 0, 0.5)\n);\n\n// borders\n$progressBarBackground: rgb(243, 239, 239);\n$lightBorder1: rgba(211, 211, 211, 0.397);\n$educationCardBorder: #a9a7f9;\n\n// hovers\n$achievementCertificateCardHoverDark: rgba(255, 255, 255, 0.2);\n$blogCardHoverSmallColor: rgba(255, 255, 255, 0.8);\n$headerHoverBG: #f4f4f4;\n$contactDetailHoverTS: #b5b5b5;\n\n// misc backgrounds\n$progressBarSpanBG: #aaa5ff;\n$iconBackground: #333;\n$appHeaderBG: #282c34;\n\n// misc colors\n$skillsColor: #645beb;\n$appLink: #09d3ac;\n\n// social media icons\n$faceBook: #3b5998;\n$linkedin: #0e76a8;\n$github: #333;\n$gitlab: #fca326;\n$google: #ea4335;\n$twitter: #1da1f2;\n$medium: #000;\n$stackoverflow: #f48024;\n$instagram: #c13584;\n$kaggle: #20beff;\n","@import \"../../_globalColor\";\n\n.small-dark {\n  color: $textColorDark !important;\n}\n\n.blog-container {\n  border-radius: 10px;\n  color: $blogCardContainerColor;\n  background-color: $lightBackground1;\n  box-shadow: 0 0 36px $lightBoxShadow;\n  cursor: pointer;\n  height: 200px;\n}\n\n.blog-title {\n  color: $blogCardTitleColor;\n  font-size: 1.375rem;\n  line-height: 24px;\n  font-weight: 700;\n  margin-left: 20px;\n  margin-right: 20px;\n  margin-bottom: 14px;\n  margin-top: 32px;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.small {\n  font-size: 1.063rem;\n  font-weight: 400;\n  line-height: 1.5rem;\n  color: $cardSubtitle;\n  padding: 0px 20px;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 4;\n  -webkit-box-orient: vertical;\n  margin: 0px;\n}\n\n.go-corner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  width: 32px;\n  height: 32px;\n  overflow: hidden;\n  top: 0;\n  right: 0;\n  background-color: $buttonColor;\n  border-radius: 0 4px 0 32px;\n}\n\n.go-arrow {\n  margin-top: -4px;\n  margin-right: -4px;\n  color: $textColorDark;\n  font-family: courier, sans;\n}\n\n.blog-card {\n  display: block;\n  position: relative;\n  background-color: transparent;\n  border-radius: 4px;\n  text-decoration: none;\n  z-index: 0;\n  overflow: hidden;\n  height: 100%;\n}\n\n.blog-card::before {\n  content: \"\";\n  position: absolute;\n  z-index: -1;\n  top: -16px;\n  right: -16px;\n  background: $buttonColor;\n  height: 32px;\n  width: 32px;\n  border-radius: 32px;\n  transform: scale(1);\n  transform-origin: 50% 50%;\n  transition: transform 0.4s ease-out;\n}\n\n.blog-card:hover::before {\n  transform: scale(30);\n}\n\n.blog-card:hover > .small {\n  transition: all 0.3s ease-out;\n  color: $blogCardHoverSmallColor;\n}\n\n.blog-card:hover > h3 {\n  transition: all 0.3s ease-out;\n  color: $darkBoxShadow2;\n}\n\n@media screen and (max-width: 480px) and (min-width: 300px),\n  (min-width: 925px) and (max-width: 1024px),\n  (min-width: 1405px) and (max-width: 1550px) {\n  .blog-card:hover::before {\n    transform: scale(30);\n  }\n}\n\n@media screen and (min-width: 481px) and (max-width: 675px),\n  (min-width: 1025px) and (max-width: 1404px),\n  (min-width: 1551px) {\n  .blog-card:hover::before {\n    transform: scale(40);\n  }\n  .blog-card::before {\n    transition: transform 0.45s ease-out;\n  }\n}\n\n@media screen and (min-width: 675px) and (max-width: 860px) {\n  .blog-card:hover::before {\n    transform: scale(50);\n  }\n  .blog-card::before {\n    transition: transform 0.5s ease-out;\n  }\n}\n\n@media screen and (min-width: 860px) and (max-width: 924px) {\n  .blog-card:hover::before {\n    transform: scale(60);\n  }\n  .blog-card::before {\n    transition: transform 0.5s ease-out;\n  }\n}\n\n@media screen and (max-width: 480px) and (min-width: 300px) {\n  .blog-title {\n    font-size: 1.125rem;\n  }\n}\n.blog-card-shadow {\n  box-shadow: 1px 0px 20px $darkBoxShadow2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
